module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II11.24ab6685.png";